import { render, staticRenderFns } from "./OrderMaterial.vue?vue&type=template&id=4cbb3e24&"
import script from "./OrderMaterial.vue?vue&type=script&lang=js&"
export * from "./OrderMaterial.vue?vue&type=script&lang=js&"
import style0 from "./OrderMaterial.vue?vue&type=style&index=0&id=4cbb3e24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports